import { render } from "./view_approved_applicant.html?vue&type=template&id=90d1c714&external"
import script from "./view_approved_applicant.js?vue&type=script&lang=js&external"
export * from "./view_approved_applicant.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__